import PageHero from 'tio-ui/components/page-hero';
import { Section, VStack } from 'tio-ui/components/layout';
import Button from 'tio-ui/components/button';
import Card from 'tio-ui/components/card';
import IconBadge from 'tio-ui/components/icon-badge';
import StepCard from 'tio-ui/components/step-card';
import { concat } from '@ember/helper';
import { t } from 'ember-intl';
import { PhThumbsUp, PhMedal, PhTrophy } from 'ember-phosphor-icons';
<template>
  <VStack class="gap-8">
    <PageHero
      @icon={{PhTrophy}}
      @title={{t "planning_for_college.scholarship.hero_title"}}
      @subtitle={{t "planning_for_college.scholarship.hero_detail"}}
      @gradient="brand-soft"
      class="tio-elevation-card-raised"
    >
      <:content>
        <p class="tio-text-base-medium app-rich-text">
          {{t "planning_for_college.scholarship.learn_about" htmlSafe=true}}
        </p>
      </:content>
      <:actions>
        <Button
          @intent="primary"
          @href="https://www.lendkey.com/scholarship-search/?sk=AFF-Tuitionio&utm_source=AFF-Tuitionio&utm_medium=referral&utm_campaign=AFF"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{t "planning_for_college.scholarship.search_button" htmlSafe=true}}
        </Button>
      </:actions>
    </PageHero>

    <Section>
      <:header>
        {{t "planning_for_college.scholarship.pros_scholarship"}}
      </:header>
      <:body>
        <div class="app-card-grid app-card-grid--medium">
          <Card @radius="card" @elevation="card" @padding="md" class="tio-stack-center text-center">
            <IconBadge @icon={{PhThumbsUp}} @color="teal" @size="lg" />
            <p class="tio-text-base-medium tio-fg-secondary mt-2">
              {{t "planning_for_college.scholarship.pro_1"}}
            </p>
          </Card>
          <Card @radius="card" @elevation="card" @padding="md" class="tio-stack-center text-center">
            <IconBadge @icon={{PhMedal}} @color="teal" @size="lg" />
            <p class="tio-text-base-medium tio-fg-secondary mt-2">
              {{t "planning_for_college.scholarship.pro_2"}}
            </p>
          </Card>
        </div>
      </:body>
    </Section>

    <Section>
      <:header>
        {{t "planning_for_college.scholarship.cons_scholarship"}}
      </:header>
      <:body>
        <p>{{t "planning_for_college.scholarship.con_1"}}</p>
      </:body>
    </Section>

    <Section>
      <:header>
        {{t "planning_for_college.scholarship.how_to_apply"}}
      </:header>
      <:body>
        <div class="tio-col">
          <StepCard
            @step={{1}}
            @title={{t "planning_for_college.scholarship.search" htmlSafe=true}}
            @description={{t "planning_for_college.scholarship.learn_about" htmlSafe=true}}
          />
          <StepCard
            @step={{2}}
            @title={{t "planning_for_college.scholarship.apply" htmlSafe=true}}
            @description={{concat
              (t "planning_for_college.scholarship.apply_li_1")
              " "
              (t "planning_for_college.scholarship.apply_li_2")
            }}
          />
          <StepCard
            @step={{3}}
            @title={{t "planning_for_college.scholarship.keep_up" htmlSafe=true}}
            @description={{t "planning_for_college.scholarship.keep_up_detail"}}
          />
        </div>
      </:body>
    </Section>
  </VStack>
</template>
